import { Dialog, DialogActionsBar } from '@progress/kendo-react-dialogs';
import { Button } from '@progress/kendo-react-buttons';

interface VBClaimsModalProps {
  onGoBack: () => void;
  onContinue: () => void;
}

const VBClaimsModal = ({ onGoBack, onContinue }: VBClaimsModalProps) => (
  <Dialog
    title="Voluntary Benefit Claims"
    onClose={onGoBack}
    width={443}
    id="vb-claims-modal"
  >
    <div className="tw-py-2 tw-font-sans tw-text-base tw-leading-6">
      <p>
        It looks like you haven&apos;t selected any Voluntary Benefit Claims to
        receive your document(s).
      </p>
      <p className="tw-mb-0">
        Would you like to continue, or go back and make a selection?
      </p>
    </div>
    <DialogActionsBar layout="end">
      <Button id="vb-claims-modal-go-back" onClick={onGoBack}>
        Go back
      </Button>
      <Button
        id="vb-claims-modal-continue"
        themeColor="primary"
        onClick={onContinue}
      >
        Continue
      </Button>
    </DialogActionsBar>
  </Dialog>
);

export default VBClaimsModal;
